import { useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";

const diasSemana = {
  1: "Lunes",
  2: "Martes",
  3: "Miércoles",
  4: "Jueves",
  5: "Viernes",
  6: "Sábado",
  7: "Domingo",
};

export default function TiposAtenHorarios({
  show,
  onClose,
  tipoAtencion,
  horarios,
  onAdd,
  onEdit,
  onDelete,
}) {
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});

  const handleEditClick = (h) => {
    setEditingId(h.ideAgenda);
    setEditValues({ ...h });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditValues({});
  };

  const handleSaveEdit = () => {
    onEdit(editValues); // Llama al PUT en el front
    setEditingId(null);
    setEditValues({});
  };

  const handleChange = (field, value) => {
    setEditValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleAdd = () => {
    const ideDia = document.getElementById("nuevoDia").value;
    const start_time = document.getElementById("nuevoInicio").value;
    const end_time = document.getElementById("nuevoFin").value;
    onAdd({ ideDia, start_time, end_time });
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Horarios - {tipoAtencion?.nombre ?? ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Día</th>
              <th>Hora Inicio</th>
              <th>Hora Fin</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {horarios.map((h) => (
              <tr key={h.ideAgenda}>
                <td>
                  {editingId === h.ideAgenda ? (
                    <select
                      value={editValues.ideDia}
                      onChange={(e) =>
                        handleChange("ideDia", parseInt(e.target.value))
                      }
                      className="form-control"
                    >
                      {Object.entries(diasSemana).map(([k, v]) => (
                        <option key={k} value={k}>
                          {v}
                        </option>
                      ))}
                    </select>
                  ) : (
                    diasSemana[h.ideDia]
                  )}
                </td>
                <td>
                  {editingId === h.ideAgenda ? (
                    <input
                      type="time"
                      value={editValues.start_time}
                      onChange={(e) =>
                        handleChange("start_time", e.target.value)
                      }
                      className="form-control"
                    />
                  ) : (
                    h.start_time
                  )}
                </td>
                <td>
                  {editingId === h.ideAgenda ? (
                    <input
                      type="time"
                      value={editValues.end_time}
                      onChange={(e) => handleChange("end_time", e.target.value)}
                      className="form-control"
                    />
                  ) : (
                    h.end_time
                  )}
                </td>
                <td>
                  {editingId === h.ideAgenda ? (
                    <>
                      <button
                        className="btn btn-sm btn-success me-2"
                        onClick={handleSaveEdit}
                      >
                        ✅
                      </button>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={handleCancelEdit}
                      >
                        ❌
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="btn btn-sm btn-success me-2"
                        onClick={() => handleEditClick(h)}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => onDelete(h.ideAgenda)}
                        style={{"color": "white" }}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <select id="nuevoDia" className="form-control">
                  {Object.entries(diasSemana).map(([k, v]) => (
                    <option key={k} value={k}>
                      {v}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input type="time" id="nuevoInicio" className="form-control" />
              </td>
              <td>
                <input type="time" id="nuevoFin" className="form-control" />
              </td>
              <td>
                <button className="btn btn-sm btn-warning" onClick={handleAdd}>
                  ➕
                </button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
